export type EmbedMode = "modal" | "inline";

export function isValidEmbedMode(value: string | null): value is EmbedMode {
  return value === "modal" || value === "inline";
}
